import { Base } from './base.model';

export class Report extends Base {
  public createDate: Date;
  public name: string;
}
